import fp from "lodash/fp";

import { ACHProcessorData as ach } from "globalConstants";

export default function mapAchProcessorData(form) {
	if (fp.isEmpty(form)) return;
	const copyBillingInfo = form[ach.IsApplyBankAccountData.name] === "true";

	const achProcessorModel = {
		achProcessorData: {
			[ach.MonthlyVolumeAch.beName]: form[ach.MonthlyVolumeAch.name],
			[ach.MonthlyVolumeAchPayouts.beName]:
				form[ach.MonthlyVolumeAchPayouts.name],
			[ach.HighTicketAch.beName]: form[ach.HighTicketAch.name],
			[ach.HighTicketAchPayouts.beName]:
				form[ach.HighTicketAchPayouts.name],
			[ach.TicketCountAch.beName]: form[ach.TicketCountAch.name],
			[ach.TicketCountAchPayouts.beName]:
				form[ach.TicketCountAchPayouts.name],
			[ach.StatementDescriptor.beName]:
				form[ach.StatementDescriptor.name],
			[ach.UseOfPaymentServiceDescription.beName]:
				form[ach.UseOfPaymentServiceDescription.name],
			[ach.IsApplyBankAccountData.beName]:
				form[ach.IsApplyBankAccountData.name],
			[ach.BillingRouting.beName]: copyBillingInfo
				? form?.routing
				: form[ach.BillingRouting.name],
			[ach.BillingBank.beName]: copyBillingInfo
				? form?.bank
				: form[ach.BillingBank.name],
			[ach.BillingAccount.beName]: copyBillingInfo
				? form?.account
				: form[ach.BillingAccount.name],
			[ach.BillingAccountName.beName]: copyBillingInfo
				? form?.accountName
				: form[ach.BillingAccountName.name],
			[ach.CustomerType.beName]: form[ach.CustomerType.name],
			[ach.PaymentAuthorizationType.beName]:
				form[ach.PaymentAuthorizationType.name],
		},
	};

	return form?.achProcessorHidden ? achProcessorModel : null;
}
